import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBuyButtonArticleNumber } from '../../Actions/BuyButton.action';
import VariantPickerOption from './types/VariantPickerOption';
import VariantPickerProps from './types/VariantPickerProps';
import { createUseStyles } from 'react-jss';
import { Theme } from '../../styling/variables';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import styled from 'styled-components';
import buttons from '../../styling/utils/buttons';
import Button from '../Button';
import { getColor } from '../../styling/mixins/colors';

interface VariantButtonStylingProps {
  selected?: boolean;
}
const StyledVariantWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
`;

const StyledVariantButton = styled(Button)<VariantButtonStylingProps>`
  height: 40px;
  min-width: 40px;
  background-color: ${(props) =>
    props.selected ? getColor('primary', 50) : null};
`;

const VariantPickerButtons = ({
  options,
  selectedValue,
}: VariantPickerProps) => {
  const dispatch = useDispatch();

  const { articleNumber } = useTypedSelector((state) => state.buyButton);

  const onClick = useCallback(
    (option: VariantPickerOption) => {
      dispatch(setBuyButtonArticleNumber(option.value));
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectedValue) {
      let option = options.find((opt) => opt.value == selectedValue);
      setTimeout(() => option && onClick(option), 1);
    }
  }, [dispatch, selectedValue, onClick, options]);

  return (
    <StyledVariantWrapper>
      {options != null ? options.map((opt, idx) => (
        <StyledVariantButton
          btnType={'outlined'}
          btnSize={'medium'}
          disabled={opt.disabled}
          onClick={() => onClick(opt)}
          key={'variant-picker' + opt.value + idx}
          selected={opt.value == articleNumber}
        >
          {opt.label}
        </StyledVariantButton>
      )) : ""}
    </StyledVariantWrapper>
  );
};

export default VariantPickerButtons;
